import src from "IMAGE";
export default { src, width: 300, height: 300, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRnoAAABXRUJQVlA4TG0AAAAvB8ABEM1VICICEeGBACChAQAAnH/1oB5UQQJABIoCAIQEAQBDCkSECBQhhAAkAAKJkEABwKCQACQUEAC4JIl9jx2yh1AhbawAcQ51lIWBkx8o4rTZrmCe173m9LfsSA+lGfh67LQ+auU/81YxAA=="};
